import { useMemo } from "react";

import { t } from "i18n/i18n";
import { IconText } from "mds/components/IconText";
import { RoundedButton } from "mds/components/buttons/RoundedButton";
import { HandRaiseOutlineIcon, SoundLevelOnIcon } from "mds/icons";
import { useAppSelector } from "store/index";
import { selectLocalMicIsEnabled } from "store/selectors";
import {
  selectIsCurrentUserInDistributedParticipantBar,
  selectIsLargeClass,
} from "store/selectors/virtual-class-users-sorting";
import { useAv } from "utils/av";

export const LargeClassHandControl = () => {
  const isLargeClass = useAppSelector(selectIsLargeClass);
  const isBeingSubscribedTo = useAppSelector(selectIsCurrentUserInDistributedParticipantBar);
  const isLocalMicEnabled = useAppSelector(selectLocalMicIsEnabled);
  const { isHandRaised, toggleHand } = useAv();

  const displayOnly = isBeingSubscribedTo && !isHandRaised;
  const shouldShow = isLargeClass && (!isLocalMicEnabled || isHandRaised);

  const text = useMemo(() => {
    if (isHandRaised) return t("av.raised_hand");
    if (isBeingSubscribedTo) return isLocalMicEnabled ? "" : t("av.unmute_to_speak");
    return t("av.raise_hand_to_speak");
  }, [isHandRaised, isBeingSubscribedTo, isLocalMicEnabled]);

  if (!shouldShow) return null;

  if (displayOnly) {
    return (
      <IconText
        className="ml-2 whitespace-nowrap text-black-tint-55"
        iconStart={<SoundLevelOnIcon />}
        text={text}
      />
    );
  }

  return (
    <RoundedButton
      className="ml-2"
      kind={isHandRaised ? "secondary" : "tertiary"}
      onClick={toggleHand}
    >
      <IconText iconStart={<HandRaiseOutlineIcon />} text={text} />
    </RoundedButton>
  );
};
